import styled from 'styled-components';

export const Container = styled.div`
  .titleWrapper {
    height: 117px;
  }

  .TitleContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 1030px) {
      flex-direction: column;
      margin-top: -10px;
    }

    @media only screen and (max-width: 768px) {
      flex-direction: column;
      margin-top: -30px;
    }
  }

  .buttons {
    display: flex;
    button {
      display: flex;
      font-size: 0.9rem;
      align-items: center;
      margin-right: 10px;
      transition: background 0.3s ease;

      &:hover {
        background: #b14729;
      }
      @media only screen and (max-width: 768px) {
        margin: 10px 0;
      }
    }
  }

  .departments {
    margin-top: 26px;
    @media only screen and (max-width: 900px) {
      width: 109%;
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: -30px;
    }
  }
`;

export const Title = styled.h1`
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: bold;
  font-size: 45px;
  line-height: 59px;

  color: var(--orange);
`;

export const FiltersContainer = styled.div`
  margin-top: 25px;
  display: flex;
  align-items: flex-start;

  .filter {
    margin-right: 5px;
    button {
      display: flex;
      align-items: center;
      transition: background 0.3s ease;
      color: black;

      &:hover {
        background: #9ea1a2;
      }
    }
  }

  .search {
    width: 100%;
    form {
      position: relative;
    }
    div {
      height: 40px;
      margin-top: -4px;
      input {
        font-size: 18px;
      }
    }
    .searchButton {
      position: absolute;
      right: 0px;
      top: 0;
      display: flex;
      align-items: center;
      transition: background 0.3s ease;

      &:hover: {
        background: red;
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  button {
    color: #403e3e;
    height: 30px;
    width: 30px;
    border-radius: 5px;
    margin-right: 5px;
    font-family: 'Source Sans Pro' sans-serif;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .trash {
    font-size: 1.5rem;
    background: transparent;
  }

  .edit {
    font-size: 1.5rem;
    background: transparent;
  }
`;
